(function () {
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Glows "se prenden" (luz que enciende) con su propia clase para no
        // interferir con el estado sl4-anim--visible de los data-anim.
        const cls = entry.target.classList.contains('sl4-glow--ignite')
          ? 'sl4-anim--lit'
          : 'sl4-anim--visible';
        entry.target.classList.add(cls);
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.05, rootMargin: '0px 0px 60px 0px' });

  function observe() {
    // .sl4-ct-faq__card (FAQ de contacto) comparte el reveal de panel de los
    // FAQ sin tocar sl4-contacto.liquid: su estado inicial vive en
    // sl4-animations.css y aquí solo se observa como un data-anim más.
    document
      .querySelectorAll('[data-anim], .sl4-glow--ignite, .sl4-ct-faq__card')
      .forEach((el) => io.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
